import request from '@/axios/index.js'

export function getMenuList(data) {
    return request.axios({
        data:data,
        url: '/menu/init'
    })
}
export function getMenuApi(data) {
    return request.axios({
        data:data,
        url: '/menu/get'
    })
}
export function updateApi(data) {
    return request.axios({
        data:data,
        url: '/menu/update'
    })
}


// WEBPACK FOOTER //
// ./src/api/menu.js